import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ba36956"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_pre_stock_out_list",
  ref: "addPreStockOutList",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1250px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header px-9",
  id: "kt_modal_add_merchant_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  key: 0,
  class: "row"
}
const _hoisted_11 = {
  key: 0,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_12 = { class: "form-label fw-bold required" }
const _hoisted_13 = { class: "el-form-item__content" }
const _hoisted_14 = { class: "col-md-3 form-group mb-7" }
const _hoisted_15 = { class: "form-label fw-bold required" }
const _hoisted_16 = { class: "el-form-item__content" }
const _hoisted_17 = { class: "col-md-3 form-group mb-7" }
const _hoisted_18 = { class: "form-label fw-bold" }
const _hoisted_19 = { class: "el-form-item__content" }
const _hoisted_20 = { class: "col-md-3 form-group mb-7" }
const _hoisted_21 = { class: "form-label fw-bold" }
const _hoisted_22 = { class: "el-form-item__content" }
const _hoisted_23 = { class: "col-md-3 form-group mb-7" }
const _hoisted_24 = { class: "form-label fw-bold" }
const _hoisted_25 = { class: "el-form-item__content" }
const _hoisted_26 = { class: "card-header py-5 px-9" }
const _hoisted_27 = {
  key: 0,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_28 = { class: "svg-icon svg-icon-3 svg-icon-danger" }
const _hoisted_29 = { class: "text-danger" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "d-flex gap-3 justify-content-end" }
const _hoisted_32 = { class: "svg-icon svg-icon-3" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "indicator-label" }
const _hoisted_35 = { class: "svg-icon svg-icon-3" }
const _hoisted_36 = { class: "indicator-progress" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = { class: "modal-body p-0" }
const _hoisted_40 = { class: "text-nowrap" }
const _hoisted_41 = { class: "text-gray-800" }
const _hoisted_42 = { class: "fs-7 text-gray-400" }
const _hoisted_43 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_44 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_45 = { class: "modal-footer justify-content-between py-5 px-9" }
const _hoisted_46 = {
  key: 0,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_47 = { class: "svg-icon svg-icon-3 svg-icon-danger" }
const _hoisted_48 = { class: "text-danger" }
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "d-flex gap-3 justify-content-end" }
const _hoisted_51 = { class: "svg-icon svg-icon-3" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "indicator-label" }
const _hoisted_54 = { class: "svg-icon svg-icon-3" }
const _hoisted_55 = { class: "indicator-progress" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: _ctx.formData,
      rules: _ctx.rules,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("shipments.selectProducts")), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.props.fulfillment_order_number == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_ctx.props.submitData.shipment_type != '1')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("shipments.warehouse")) + ":", 1),
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_el_select, {
                                  class: "w-100",
                                  modelValue: _ctx.formData.destination_warehouse_id,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.destination_warehouse_id) = $event)),
                                  filterable: "",
                                  clearable: "",
                                  disabled: _ctx.loading,
                                  placeholder: _ctx.t('common.plsSelect'),
                                  onChange: _ctx.updatePreStockOutList
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.warehouse, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.value,
                                        label: item.label,
                                        value: item.value
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled", "placeholder", "onChange"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("shipments.orderCountry")) + ":", 1),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_el_select, {
                              class: "w-100 country-select",
                              modelValue: _ctx.formData.country,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.country) = $event)),
                              multiple: "",
                              "collapse-tags": "",
                              "collapse-tags-tooltip": "",
                              filterable: "",
                              clearable: "",
                              disabled: _ctx.loading,
                              placeholder: _ctx.t('common.plsSelect'),
                              onChange: _ctx.updatePreStockOutList
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.country, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled", "placeholder", "onChange"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("order.relatedSalesOrder")) + ":", 1),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.sale_order_number,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.sale_order_number) = $event)),
                              type: "text",
                              clearable: "",
                              disabled: _ctx.loading,
                              placeholder: _ctx.t('common.plsEnter'),
                              onInput: _ctx.updatePreStockOutList
                            }, null, 8, ["modelValue", "disabled", "placeholder", "onInput"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t("salesOrder.customer")) + ":", 1),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              modelValue: _ctx.formData.customer,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.customer) = $event)),
                              filterable: "",
                              clearable: "",
                              "remote-show-suffix": "",
                              remote: "",
                              disabled: _ctx.loading,
                              placeholder: _ctx.t('common.plsEnter'),
                              "remote-method": _ctx.searchCustomerItems,
                              loading: _ctx.options.customerLoading,
                              onChange: _ctx.updatePreStockOutList
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.customer, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled", "placeholder", "remote-method", "loading", "onChange"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("salesOrderOverview.operatingEntity")) + ":", 1),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              modelValue: _ctx.formData.owner_id,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.owner_id) = $event)),
                              filterable: "",
                              clearable: "",
                              disabled: _ctx.loading,
                              placeholder: _ctx.t('common.plsSelect'),
                              onChange: _ctx.updatePreStockOutList
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.getters.currentOwner, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled", "placeholder", "onChange"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.getSelectOwner.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                        ]),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.t("shipments.itemsSelectedError", [
                      _ctx.formData.stock_out_ids.length,
                    ])), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "d-flex align-items-center",
                        innerHTML: 
                    _ctx.t('shipments.itemsSelected', [
                      _ctx.formData.stock_out_ids.length,
                    ])
                  
                      }, null, 8, _hoisted_30)),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_32, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToPrevious")), 1)
                    ]),
                    _createElementVNode("button", {
                      ref: _ctx.submitButton,
                      type: "button",
                      class: "btn btn-lg btn-primary",
                      disabled: _ctx.isDisabledSubmit,
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_34, [
                        _createElementVNode("span", _hoisted_35, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_36, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_37
                      ])
                    ], 8, _hoisted_33)
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_el_table, {
                      class: "mb-7 w-100",
                      ref: "multipleTableRef",
                      data: _ctx.options.list,
                      "table-layout": "auto",
                      "cell-class-name": _ctx.setCellCalss,
                      onSelect: _ctx.handleSelectChange,
                      onSelectionChange: _ctx.handleSelectionChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          type: "selection",
                          width: "50",
                          selectable: _ctx.isSelectable
                        }, null, 8, ["selectable"]),
                        (
                        _ctx.props.fulfillment_order_type !=
                        _ctx.FulfillmentSource.Merchant
                      )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 0,
                              label: _ctx.t('order.orderNo')
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(row.sale_order_number), 1),
                                  _createElementVNode("div", _hoisted_42, " SUB#" + _toDisplayString(row.position), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (
                        _ctx.props.fulfillment_order_type !=
                        _ctx.FulfillmentSource.Merchant
                      )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 1,
                              width: "110",
                              label: _ctx.t('salesOrder.orderDateTime')
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", null, _toDisplayString(_ctx.formatDate(row.order_date)), 1)
                                ])
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (
                        _ctx.props.fulfillment_order_type !=
                        _ctx.FulfillmentSource.Merchant
                      )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 2,
                              label: _ctx.t('order.article'),
                              width: "200"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createVNode(_component_product_info, {
                                  gallery: row.relation_sku.gallery,
                                  name: row.relation_sku.name,
                                  name_en: row.relation_sku.name_en,
                                  source_link: row.relation_sku.source_link,
                                  brand_id: row.relation_sku.brand
                                }, null, 8, ["gallery", "name", "name_en", "source_link", "brand_id"])
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (
                        _ctx.props.fulfillment_order_type !=
                        _ctx.FulfillmentSource.Merchant
                      )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 3,
                              label: _ctx.t('order.sku')
                            }, {
                              default: _withCtx(({ row }) => [
                                _createVNode(_component_sku_info, {
                                  class: "w-100",
                                  brand_article_no: row.relation_sku.brand_article_no,
                                  color: row.relation_sku.original_color,
                                  size: row.relation_sku.size,
                                  product_identifier_id: '0'
                                }, null, 8, ["brand_article_no", "color", "size"])
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (
                        _ctx.props.fulfillment_order_type !=
                        _ctx.FulfillmentSource.Merchant
                      )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 4,
                              label: _ctx.t('shipments.qty'),
                              width: "70",
                              align: "right"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", null, _toDisplayString(row.actual_quantity), 1),
                                  (row.order_all_paid === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.t("salesOrder.paymentStatusPartialPaid")), 1))
                                    : (row.inventory_locked === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.t("salesOrder.inventoryLocked")), 1))
                                      : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (
                        _ctx.props.fulfillment_order_type !=
                        _ctx.FulfillmentSource.Merchant
                      )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 5,
                              label: _ctx.t('shipments.orderCountry'),
                              prop: "shipping_address"
                            }, null, 8, ["label"]))
                          : _createCommentVNode("", true),
                        (
                        _ctx.props.fulfillment_order_type !=
                        _ctx.FulfillmentSource.Merchant
                      )
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 6,
                              label: _ctx.t('order.customer'),
                              prop: "customer_name"
                            }, null, 8, ["label"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["data", "cell-class-name", "onSelect", "onSelectionChange"])
                  ])
                ])), [
                  [_directive_loading, _ctx.loading]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              (_ctx.getSelectOwner.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("span", _hoisted_47, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen044.svg" })
                    ]),
                    _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.t("shipments.itemsSelectedError", [
                  _ctx.formData.stock_out_ids.length,
                ])), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "d-flex align-items-center",
                    innerHTML: 
                _ctx.t('shipments.itemsSelected', [_ctx.formData.stock_out_ids.length])
              
                  }, null, 8, _hoisted_49)),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
                }, [
                  _createElementVNode("span", _hoisted_51, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToPrevious")), 1)
                ]),
                _createElementVNode("button", {
                  ref: _ctx.submitButton,
                  type: "button",
                  class: "btn btn-lg btn-primary",
                  disabled: _ctx.isDisabledSubmit,
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, [
                  _createElementVNode("span", _hoisted_53, [
                    _createElementVNode("span", _hoisted_54, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_55, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_56
                  ])
                ], 8, _hoisted_52)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ], 512))
}